import { PermissionResource } from '@coin/shared/core/util-enums';
import { TreeNode } from '../route-builder';

export const HeadcountModule = {
  segment: 'headcount',
  title: '',
  children: {
    HeadcountComponent: {
      segment: '',
      title: 'home.headcount',
      navigationRoot: true,
      children: {
        HeadcountRequestSettingsComponent: {
          segment: 'settings',
          title: 'headcount-settings.headline',
          icon: 'badge'
        },
        HeadcountWorkflowsComponent: {
          segment: 'workflows',
          title: 'headcount-settings.workflows.headline',
          icon: 'how_to_reg'
        },
        OrganisationOperationsComponent: {
          segment: 'organisation-operations',
          title: 'headcount-organisation-operations.headline',
          icon: 'cloud_upload'
        },
        JobAdTemplatesComponent: {
          segment: 'job-ad-templates',
          // TODO: replace with a CMS translation key once published; the feature's
          // mock translations are merged lazily and would otherwise show a raw key
          // in the eagerly-rendered navigation.
          title: 'Job Ad Templates',
          icon: 'description',
          // Visible to headcount admins and to any role granted the dedicated
          // JobAdTemplateAdmin permission (kept in sync with the route guard).
          permissions: [
            PermissionResource.HeadcountApprovalAdmin,
            PermissionResource.ApprovalWorkflowsAdmin,
            PermissionResource.JobAdTemplateAdmin
          ],
          children: {
            JobAdTemplatesListComponent: { segment: '', title: 'Templates' },
            JobAdStaticTextsListComponent: { segment: 'static-texts', title: 'Static Texts' }
          }
        }
      }
    }
  }
} as const satisfies TreeNode;
